import { SummaryPaneResult } from 'src/apps/mobile-common/types/CommonTypes';
import { ISeverityCountType } from 'src/common/components/mobile-scans-impacted-by-severity-chart/MobileScansImpactedBySeverityChart';
import { gqlClient } from 'src/common/services/api/GraphQLRequestApi';
import { Logger } from 'src/common/services/Logger';
import { MobileIssueTypeCount } from 'src/common/types/MobileSingleSessionTypes';

import { buildMobileSdkIssueVariables } from './queries/issue/helpers/buildVariables';
import {
	IMobileSdkIssueData,
	transformMobileSdkIssueResults
} from './queries/issue/helpers/transformResults';
import { MobileSdkIssueQuery } from './queries/issue/MobileSdkIssue.generated';
import { MobileSdkIssue } from './queries/issue/MobileSdkIssue.gql';
import { buildMobileSdkTestIssueTypesQueryVariables } from './queries/test-issue-types/helpers/buildVariables';
import { transformMobileSdkTestIssueTypesResults } from './queries/test-issue-types/helpers/transformResults';
import { MobileSdkTestIssueTypesQuery } from './queries/test-issue-types/MobileSdkTestIssueTypes.generated';
import { MobileSdkTestIssueTypes } from './queries/test-issue-types/MobileSdkTestIssueTypes.gql';
import { buildMobileSdkTestSeveritiesQueryVariables } from './queries/test-severities/helpers/buildVariables';
import { transformMobileSdkTestSeveritiesResults } from './queries/test-severities/helpers/transformResults';
import { MobileSdkTestSeveritiesQuery } from './queries/test-severities/MobileSdkTestSeverities.generated';
import { MobileSdkTestSeverities } from './queries/test-severities/MobileSdkTestSeverities.gql';
import { buildMobileSdkTestSummaryQueryVariables } from './queries/test-summary/helpers/buildVariables';
import { transformMobileSdkTestSummaryResults } from './queries/test-summary/helpers/transformResults';
import { MobileSdkTestSummaryQuery } from './queries/test-summary/MobileSdkTestSummary.generated';
import { MobileSdkTestSummary } from './queries/test-summary/MobileSdkTestSummary.gql';

export const getMobileSdkTestSummary = async ({
	testId
}: {
	testId: string;
}): Promise<SummaryPaneResult> => {
	try {
		const variables = buildMobileSdkTestSummaryQueryVariables(testId);
		const result = await gqlClient.request<MobileSdkTestSummaryQuery>(
			MobileSdkTestSummary,
			variables
		);

		return transformMobileSdkTestSummaryResults(result);
	} catch (e) {
		Logger.error('MobileSdkSingleTestService -> getMobileSdkTestSummary failed with an error:', e);
		throw e;
	}
};

export const getMobileSdkTestIssueTypes = async ({
	testId
}: {
	testId: string;
}): Promise<MobileIssueTypeCount[]> => {
	try {
		const variables = buildMobileSdkTestIssueTypesQueryVariables(testId);
		const result = await gqlClient.request<MobileSdkTestIssueTypesQuery>(
			MobileSdkTestIssueTypes,
			variables
		);

		return transformMobileSdkTestIssueTypesResults(result);
	} catch (e) {
		Logger.error(
			'MobileSdkSingleTestService -> getMobileSdkTestIssueTypes failed with an error:',
			e
		);
		throw e;
	}
};

export const getMobileSdkTestSeverities = async ({
	testId
}: {
	testId: string;
}): Promise<ISeverityCountType[]> => {
	try {
		const variables = buildMobileSdkTestSeveritiesQueryVariables(testId);
		const result = await gqlClient.request<MobileSdkTestSeveritiesQuery>(
			MobileSdkTestSeverities,
			variables
		);

		return transformMobileSdkTestSeveritiesResults(result);
	} catch (e) {
		Logger.error(
			'MobileSdkSingleTestService -> getMobileSdkTestSeverities failed with an error:',
			e
		);
		throw e;
	}
};

export const getMobileSdkIssue = async (
	issueId: string,
	testId: string
): Promise<IMobileSdkIssueData | null> => {
	try {
		const variables = buildMobileSdkIssueVariables(issueId, testId);
		const result = await gqlClient.request<MobileSdkIssueQuery>(MobileSdkIssue, variables);

		return transformMobileSdkIssueResults(result);
	} catch (e) {
		Logger.error('MobileSdkSingleTestService -> getMobileSdkIssue failed with an error:', e);
		throw e;
	}
};
